import { render, staticRenderFns } from "./phototext.vue?vue&type=template&id=6a86ea58&scoped=true"
import script from "./phototext.vue?vue&type=script&lang=js"
export * from "./phototext.vue?vue&type=script&lang=js"
import style0 from "./phototext.vue?vue&type=style&index=0&id=6a86ea58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a86ea58",
  null
  
)

export default component.exports